<template>
  <div class="thousand_layout">
    <div class="right_box seller tab_width" v-loading="loading">
      <h2 class="seller_saved_h4">{{$t('base.savedSellers')}}</h2>
      <!-- <div class="seller_screen">
        <div class="sellers_count">{{list.length}} Saved Sellerst</div>
        <div class="watch_sort_status">Sort:
            <el-select class="all_bids all_sort" v-model="Sort" @change="getSelect($event)">
              <el-option v-for="(item,index) in all_Sort" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
      </div> -->
      
     <!--  <div class="flex_layout_bids">
        <div class="seller_saved_span">7 Saved Sellerst</div>
        <div class="watch_sort_status">
          <div>Sort:
            <el-select class="all_bids all_sort" v-model="Sort">
              <el-option v-for="(item,index) in all_Sort" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div> -->
      <sellers-list class="saved_sellers" :list="list" :type="sellerType" @updatedSeller="updatedSeller"  v-if="!nofind"/>
      <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
      <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else />
      <!-- <list-pagination class="" /> -->
    </div>
  </div>
</template>
<script>
/* 模拟假数据 */


import { getInfo } from "@/api/public";
import SellersList from '@/components/list/sellers'
import ListPagination from '@/components/listpagination'
import FZF from "@/components/notnull";
import NOTN from "@/components/notnull.vue";


export default {
  name: 'tabslist',
  components: { SellersList, ListPagination,FZF,NOTN},
  data() {
    return {
      loading:false,
      pi: '1',
      sellerType: "tab",
      list: '',
      Sort: "1",
      all_Sort: this.$enumInfo.seller_sort,
      nofind:false,
      resultTpye: '',
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    this.getSeller()
  },
  mounted() {},
  methods: {
    // 获取关注商铺列表
    getSeller() {
      let that = this
      this.loading=true;
      let data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'pageIndex': that.pi, 'lag': 'en', 'searchtxt': '' }
      this.$get(this.$interface.GetAttentionSellerList, data).then(res => {
        if(res.result!=0){
          let result=res.data
          that.list=result
          that.loading=false
          if(result.length<=0){
            this.nofind=true
          }else{
            this.nofind=false
          }
        }else{
          this.nofind=true
          that.list = null;
          this.loading=false
        }
        //console.log(res)
        this.resultTpye = res.result
      })
    },
    updatedSeller() {
      this.getSeller();
    },
    // getSelect(e){
    //   console.log("e",e)
    //   this.getSeller()
    // }
  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";
.watch_sort_status{
  position: static;
  display: inline;
}
.watch_sort_status .all_bids{
  padding: 4px 0;;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/sellers.vue